import { BUTTON_COLOR, BUTTON_VARIANT } from "@shared/components/button/types";
import {
  DetailedHTMLProps,
  ElementType,
  FocusEvent,
  InputHTMLAttributes,
} from "react";

export enum INPUT_SIZE {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export interface UseInputParams {
  size: INPUT_SIZE;
  title?: string;
  error?: string | boolean;
  successMessage?: string | boolean;
  disabled?: boolean;
  parentClassName?: string;
  startIcon?: ElementType;
  startIconClassName?: string;
  endIconClassName?: string;
  inputClassName?: string;
  extraLabelClassName?: string;
}

export interface SharedInputButtonDT {
  color: BUTTON_COLOR;
  disabled?: boolean;
  text: string;
  show: boolean;
  action: ((value: string) => void) | undefined;
  className?: string;
  variant: BUTTON_VARIANT;
}

export interface SharedInputProps
  extends Omit<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    "size"
  > {
  title?: string;
  withButton?: boolean;
  required?: boolean;
  showInfoIcon?: boolean;
  startIcon?: ElementType;
  endIcon?: ElementType<any>;
  hintMessage?: string;
  showErrorIcon?: boolean;
  showSuccessIcon?: boolean;
  size?: INPUT_SIZE;
  name: string;
  touched?: boolean;
  error?: string | boolean;
  successMessage?: string | boolean;
  valueLength?: number;
  inputClassName?: string;
  startIconClassName?: string;
  endIconClassName?: string;
  endIconAction?: () => void;
  startIconAction?: () => void;
  clearHandler?: () => void;
  onBlur?: (e: FocusEvent<HTMLInputElement, Element>) => void;
  parentClassName?: string;
  button?: SharedInputButtonDT;
  labelClassName?: string;
}
